"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Employee = void 0;
const common_1 = require("../../common");
const enums_1 = require("../enums");
class Employee extends common_1.MongoDocument {
}
exports.Employee = Employee;
//# sourceMappingURL=employee.model.js.map